import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  EMPHASIS_DEFINITIONS,
  isNodeEmpty,
  Placeholder,
} from '@xingternal/content-editor-plugin-helpers';

import { EMPHASIS_TAG_NAME } from './constants';

import styles from './Emphasis.css';

const Emphasis = ({
  className,
  EMPHASIS_TAG = EMPHASIS_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === EMPHASIS_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;

      if (placeholder && isNodeEmpty(element)) {
        return (
          <EMPHASIS_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={EMPHASIS_DEFINITIONS.type}
            className={cx(styles.emphasis, className)}
          >
            {Placeholder(children, className, placeholder)}
          </EMPHASIS_TAG>
        );
      } else {
        return (
          <EMPHASIS_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={EMPHASIS_DEFINITIONS.type}
            className={cx(styles.emphasis, className)}
          >
            {children}
          </EMPHASIS_TAG>
        );
      }
    }
  };
  return RenderLeaf;
};
Emphasis.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  EMPHASIS_TAG: PropTypes.node,
};

export { Emphasis };
